import React from 'react';
import {CartItem} from "../../types";
import {FaMinus, FaPlus, FaTrashAlt} from "react-icons/fa";
import {useCart} from "../../utils/cart-context/cart-context";
import ItemAmountCounter from "./ItemAmountCounter";
import {motion} from 'framer-motion';
import {cartItem} from "../animations/animation";

type Props = {
    item: CartItem
}

const ArticleCartItem = ({item}: Props) => {

    const {removeFromCart} = useCart();

    const handleDelete = () => {
        removeFromCart(item.article, item.color);
    }


    return (
        <motion.div className="flex flex-row items-center gap-2 p-2 text-eBLUE"
                    variants={cartItem}>
            <div className="image-container" style={{width: '2rem', height: '6rem', overflow: 'hidden'}}>
                <img className="h-24 w-24 pr-1" src={item.color.image_url} alt="Image"
                     style={{objectFit: 'cover', width: '100%', height: '100%'}}/>
            </div>

            <div className="font-bold flex-1">{item.article.name} - {item.color.name}</div>
            <ItemAmountCounter item={item}/><span className="mr-8">mq</span>
            <FaTrashAlt onClick={handleDelete}
                        title="Rimuovi"
                        size={15}
                        className="cursor-pointer hover:text-red-500"/>

        </motion.div>
    );
};

export default ArticleCartItem;
